"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonTabs = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _ButtonTabDropdown = require("./ButtonTabDropdown");
var _ButtonTabsModule = _interopRequireDefault(require("./ButtonTabs.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const ButtonTabs = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    children,
    isFluid,
    size = 'medium',
    disabled,
    selectedButtonTabId,
    onButtonTabSelect,
    wrapAfter,
    wrapTabTitle = 'more',
    anchorPosition
  } = _ref;
  const childrenArray = React.Children.toArray(children);
  let unwrappedNodes = childrenArray;
  let wrappedNodes = [];
  if (typeof wrapAfter === 'number' && wrapAfter > -1) {
    unwrappedNodes = childrenArray.slice(0, wrapAfter);
    wrappedNodes = childrenArray.slice(wrapAfter);
    if (wrappedNodes.length) {
      unwrappedNodes.push( /*#__PURE__*/React.createElement(_ButtonTabDropdown.ButtonTabDropdown, {
        id: "more-tab",
        title: wrapTabTitle,
        iconName: "ellipsis-vertical",
        anchorPosition: anchorPosition,
        dropdownClass: classNames?.buttonTabDropdownWrapper
      }, wrappedNodes));
    }
  }
  const childrenWithProps = unwrappedNodes.map((child, index) => {
    if ( /*#__PURE__*/React.isValidElement(child)) {
      const {
        disabled: disabledChild,
        classNames: classNamesChild
      } = child.props;
      const isFirst = index === 0;
      const isLast = index === unwrappedNodes.length - 1;
      return /*#__PURE__*/React.cloneElement(child, {
        ...child.props,
        isFluid,
        size,
        isLeftCurved: isFirst,
        isRightCurved: isLast,
        disabled: disabledChild || disabled,
        selectedButtonTabId,
        onButtonTabSelect,
        classNames: {
          wrapper: classNamesChild?.wrapper
        }
      });
    }
    return child;
  });
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "ButtonTabs",
    ref: ref,
    className: (0, _classify.default)(_ButtonTabsModule.default.buttonTabsWrapper, {
      [_ButtonTabsModule.default.medium]: size === 'medium',
      [_ButtonTabsModule.default.small]: size === 'small',
      [_ButtonTabsModule.default.isFluid]: isFluid,
      [_ButtonTabsModule.default.disabled]: disabled
    }, classNames?.wrapper)
  }, childrenWithProps);
});
exports.ButtonTabs = ButtonTabs;